(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/services/ticket-configs.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/services/ticket-configs.js');
"use strict";


if (svs.isServer) {
  const _require = require('@svenskaspelab/trinidad-core'),
    trinidad = _require.core;
  const _trinidad$components$ = trinidad.components.require('content', 'shared'),
    apiUtils = _trinidad$components$.apiUtils;
  const ContentUrlBuilder = apiUtils.ContentUrlBuilder;
  const FEATURE_TOGGLE_CMS_API_CLIENT = 'ft-use-cms-api-client-tb';
  const fetchTicketConfigs = async req => {
    if (!(await req.feature(FEATURE_TOGGLE_CMS_API_CLIENT))) {
      try {
        const path = new ContentUrlBuilder(req, 'basicfilter').addParams({
          channel: req.capabilities.channel,
          contentType: 'cnt:ticketGame',
          count: 200
        }).build();
        const data = await trinidad.jupiter.callAsync({
          method: 'GET',
          path,
          req
        });
        return data.result;
      } catch (err) {
        throw new Error(err);
      }
    }
    try {
      const client = apiUtils.getCmsClient(req);
      const data = await client.v1.content.filter({
        channels: req.capabilities.channel,
        contentTypes: 'cnt:ticketGame',
        count: 200
      });
      return data.result;
    } catch (err) {
      throw new Error(err);
    }
  };
  module.exports = {
    fetchTicketConfigs
  };
} else {
  const fetchTicketConfigs = async () => {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-tb');
    if (useLegacyJupiterApi) {
      try {
        const path = new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({
          channel: svs.core.data.capabilities.channel,
          contentType: 'cnt:ticketGame',
          count: 200
        }).build();
        const data = await svs.core.jupiter.callAsync({
          method: 'GET',
          path
        });
        return data.response.result;
      } catch (err) {
        throw new Error(err);
      }
    }
    try {
      const client = svs.content.shared.getCmsClient();
      const data = await client.v1.content.filter({
        channels: svs.core.data.capabilities.channel,
        contentTypes: 'cnt:ticketGame',
        count: 200
      });
      return data.result;
    } catch (err) {
      throw new Error(err);
    }
  };
  setGlobal('svs.eInstant.shared.services', {
    fetchTicketConfigs
  });
}

 })(window);